export function setPositionSection() {
    let $sectionsWithAnchor = $("[data-anchor]");
    let path = window.location.href;
    let distance = 130;

    let addScrollTop = function (container) {
        setTimeout(() => {
            let offset = $(container).offset();

            $("html, body").animate({scrollTop: offset.top - distance});
        }, 500);
    };

    for (let i = 0; i < $sectionsWithAnchor.length; i++) {
        let anchor = "#" + $($sectionsWithAnchor[i]).attr("data-anchor");

        if (path.indexOf(anchor) !== -1) {
            addScrollTop($sectionsWithAnchor[i]);
        }
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/setPositionSection.js